package com.vizio.redwolf.pay.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@JsExport
sealed class CartItem {
    @Serializable
    data class NewCartItem(
        @SerialName("sku") val sku: String,
        @SerialName("quantity") val quantity: Int,
        @SerialName("signatureRequired") val signatureRequired: Boolean? = null,
        @SerialName("email") val email: String? = null,
        @SerialName("employeePurchase") val employeePurchase: Employee? = null,
    ) : CartItem()

    @Serializable
    data class AddCartItem(
        @SerialName("sku") val sku: String,
        @SerialName("quantity") val quantity: Int,
        @SerialName("signatureRequired") val signatureRequired: Boolean? = null,
    ) : CartItem()

    @Serializable
    data class CartLineItem(
        @SerialName("sku") val sku: String,
        @SerialName("type") val type: String,
        @SerialName("screenSize") val screenSize: Double,
        @SerialName("name") val name: String,
        @SerialName("signatureRequired") val signatureRequired: Boolean,
        @SerialName("quantity") val quantity: Int,
        @SerialName("price") val price: Double,
        @SerialName("savings") val savings: Double,
        @SerialName("total") val total: Double,
        @SerialName("discount") val discount: Int,
        @SerialName("promo") val promo: Int,
        @SerialName("tax") val tax: Double,
        @SerialName("recyclingFee") val recyclingFee: Double,
        @SerialName("subtotal") val subtotal: Double,
        @SerialName("available") val available: Int,
        @SerialName("freeShipping") val freeShipping: Boolean,
        @SerialName("promotionalMessage") val promotionalMessage: String?,
        @SerialName("externalId") val externalId: String,
        @SerialName("url") val url: String,
        @SerialName("images") val images: List<ItemImage>
    ) : CartItem()

    fun <R> fold (
        onNewCartItem: (NewCartItem: NewCartItem) -> R,
        onAddCartItem: (AddCartItem: AddCartItem) -> R,
        onCartLineItem: (CartLineItem: CartLineItem) -> R
    ) : R {
        return when (this) {
            is NewCartItem -> onNewCartItem(NewCartItem(this.sku, this.quantity, this.signatureRequired, this.email, this.employeePurchase))
            is AddCartItem -> onAddCartItem(AddCartItem(this.sku, this.quantity, this.signatureRequired))
            is CartLineItem -> onCartLineItem(CartLineItem(this.sku, this.type, this.screenSize, this.name, this.signatureRequired, this.quantity, this.price, this.savings, this.total, this.discount, this.promo, this.tax, this.recyclingFee, this.subtotal, this.available, this.freeShipping, this.promotionalMessage, this.externalId, this.url, this.images))
        }
    }
}

@Serializable
@JsExport
data class Employee(
    @SerialName("employeeId") val employeeId: String,
    @SerialName("employeeName") val employeeName: String,
    @SerialName("officeLocation") val officeLocation: String,
)

@Serializable
@JsExport
data class Discount(
    @SerialName("code") val code: String,
    @SerialName("name") val name: String?,
)

@Serializable
data class PostalCode(
    @SerialName("postalCode") val postalCode: String,
)

@Serializable
@JsExport
data class ItemImage(
    @SerialName("tag") val tag: String,
    @SerialName("url") val url: String,
)
